import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { listContentImages, updateContentImage } from "./actions";

export const contentImageEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity?.image?.id,
});

const initialState = contentImageEntityAdapter.getInitialState({
  totalItems: 0,
});

export const contentImageSlice = createSlice({
  name: "contentImage",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(listContentImages.fulfilled, (state, action) => {
      if (action.payload && action.payload?.statusCode === 200) {
        if (action.meta.arg.update) {
          contentImageEntityAdapter.upsertMany(state, action.payload.data.items);
        } else {
          contentImageEntityAdapter.setAll(state, action.payload.data.items);
          state.totalItems = action.payload.data.totalItems;
        }
      }
    });
    builder.addCase(updateContentImage.fulfilled, (state, action) => {
      if (action.payload.statusCode === 200) {
        contentImageEntityAdapter.upsertOne(state, action.payload.data);
      }
    });
  },
});

export default contentImageSlice.reducer;
